import React from 'react';
import styles from './AdvertsFilter.module.scss';
import CheckboxSelect from '../UI/CheckboxSelect/CheckboxSelect';
import CustomSelect from '../UI/CustomSelect/CustomSelect';
import TriggerBtn from '../UI/TriggerBtn/TriggerBtn';
import IconChevronRight from '../UI/Icons/IconChevronRight';
import IconUpdate from '../UI/Icons/IconUpdate';
import CategorySelect from './components/CategorySelect/CategorySelect';
import Modal from '../UI/Modal';
import Collections from './components/Collections/Collections';

function AdvertsFilter({onRefresh}) {
  return (
    <div className={styles.filters}>
      <div className={styles.filtersLeft}>
        {/*<div>*/}
        {/*  <Modal*/}
        {/*    modalTrigger={*/}
        {/*      <TriggerBtn*/}
        {/*        text={"Коллекция"}*/}
        {/*        icon={<IconChevronRight/>}*/}
        {/*      />*/}
        {/*    }*/}
        {/*    modalTitle={"Выберите коллекции"}*/}
        {/*    hideFooter={true}*/}
        {/*  >*/}
        {/*    <Collections/>*/}
        {/*  </Modal>*/}
        {/*</div>*/}
        <div>
          <CategorySelect/>
        </div>
        {/*<div>*/}
        {/*  <CheckboxSelect*/}
        {/*    options={[*/}
        {/*      {title: 'Моментальная продажа', value: 0},*/}
        {/*      {title: 'Аукцион', value: 1},*/}
        {/*    ]}*/}
        {/*    activeOptions={[1]}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
      <div className={styles.filtersRight}>
        {/*<div>*/}
        {/*  <CustomSelect*/}
        {/*    options={[*/}
        {/*      {value: 0, label: 'Цена: по возрастанию'},*/}
        {/*      {value: 1, label: 'Цена: по убыванию'},*/}
        {/*      {value: 2, label: 'По названию: A-Z'}*/}
        {/*    ]}*/}
        {/*    onChange={() => {}}*/}
        {/*    value={0}*/}
        {/*  />*/}
        {/*</div>*/}
        {/*<div className={styles.filtersReset}>*/}
        {/*  <TriggerBtn*/}
        {/*    text={"Сбросить фильтры"}*/}
        {/*  />*/}
        {/*</div>*/}
        <div className={styles.filtersReload}>
          <TriggerBtn
            circle
            lgIcon
            icon={<IconUpdate/>}
            onClick={onRefresh}
          />
        </div>
      </div>
    </div>
  );
}

export default AdvertsFilter;
